import React from 'react';
import PropTypes from 'prop-types';

export const IconList = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      className="icon-filled-path"
      d="M6.66667 3.33341H17.5V5.00008H6.66667V3.33341ZM3.75 5.41675C3.05964 5.41675 2.5 4.85711 2.5 4.16675C2.5 3.47639 3.05964 2.91675 3.75 2.91675C4.44036 2.91675 5 3.47639 5 4.16675C5 4.85711 4.44036 5.41675 3.75 5.41675ZM3.75 11.2501C3.05964 11.2501 2.5 10.6904 2.5 10.0001C2.5 9.30975 3.05964 8.75008 3.75 8.75008C4.44036 8.75008 5 9.30975 5 10.0001C5 10.6904 4.44036 11.2501 3.75 11.2501ZM3.75 17.0001C3.05964 17.0001 2.5 16.4404 2.5 15.7501C2.5 15.0597 3.05964 14.5001 3.75 14.5001C4.44036 14.5001 5 15.0597 5 15.7501C5 16.4404 4.44036 17.0001 3.75 17.0001ZM6.66667 9.16675H17.5V10.8334H6.66667V9.16675ZM6.66667 15.0001H17.5V16.6667H6.66667V15.0001Z"
      fill="#A1A1A1"
    />
  </svg>
);

IconList.propTypes = {
  className: PropTypes.string,
};

IconList.defaultProps = {
  className: '',
};
